/* This component CREATES one entry for the historys collection in MongoDB.
   As the entry is being CREATED, it should then activate the HistoryRead component
   to show the entry as it is being built. */

import React, { useState }          from 'react'
import axios                        from 'axios'
import Box                          from "@material-ui/core/Box"
import {
   Button,
   Grid,
   TextField,
   TextareaAutosize,
   Typography }                     from '@material-ui/core'

import HistoryReadComponent         from './HistoryReadComponent'
import PhotoSearchComponent         from './PhotoSearchComponent'
import TripleRadioOptionComponent   from '../Components/TripleRadioOptionComponent'

import {
   CLIENT_PUBLIC_TOKEN,
   historyRadioOptions
}                                   from '../config'

import { node_server }              from '../Helpers'

const HistoryCreateComponent = () => {

   const [ entry,                      setEntry                      ]  =  useState('')
   const [ entryType,                  setEntryType                  ]  =  useState('')
   const [ id,                         setId                         ]  =  useState('')
   const [ photoId,                    setPhotoId                    ]  =  useState('')
   const [ showPhotoSearchComponent,   setShowPhotoSearchComponent   ]  =  useState(true)
   const [ title,                      setTitle                      ]  =  useState('')
   const [ width,                      setWidth                      ]  =  useState(0)

   const changeEntry = (e) => {
      setEntry(e.target.value)
   }

   const changeTitle = (e) => {
      setTitle(e.target.value)
   }

   const changeWidth = (e) => {
      setWidth(e.target.value)
   }

   const getOption = (o) => {
         switch (o) {
         case 'Bullet':
            setEntryType('bullet')
         break
         case 'Link':
            setEntryType('link')
         break
         case 'Photo':
            setEntryType('photo')
         break
         case 'Text':
            setEntryType('text')
         break
         default:
         break
      }
   }

   const handleAddPhoto = ({id, filename}) => {
      console.log('id and filename are', id, 'and', filename)
      setPhotoId(id)
      setShowPhotoSearchComponent(false)
   }

   const handleSubmitTitle = async () => {

      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      if (id === '') {
         axios.post( node_server + 'history', 
         {
            title
         })
         .then( res => {
            if (res.data.msg === 'good_operation') {
               console.log('res.data', res.data)
               console.log(res.data.historyToDB)
               console.log('id', res.data.historyToDB._id)
               setId(res.data.historyToDB._id)

               // handleSnackBar({ msg: 'Your photo was added!', type:'success' })
            }
            else {
               // handleSnackBar({ msg: 'No photo yet in the database.', type:'error' })
            }
         })
         .catch( ( error, msg ) => {
console.log('error and msg are', error, msg)
         } )
      }
      else {
         axios.put((node_server + 'history'), {
            entry,
            entryType,
            id,
            photoId,
            width
         })
         .then( res => {
            console.log('PUT res.data is', res.data)
            if (res.data.msg === 'good_operation') {
               setEntry('')
            }
         })
         .catch( ( error, msg ) => {
console.log('error and msg are', error, msg)
         } )
      }
   }

   return (
      <Box>

         {id === ''
            ?
               null
            :
               <HistoryReadComponent
                  id={id}
               />
         }

         <Grid>
            <Typography variant='h5' style={{ marginTop: '6rem' }}>
               Create a Historical Entry
            </Typography>
            {id === ''
               ?
                  <Grid item xs={12} style={{ marginTop: '1rem' }} >
                     <TextField name='history-create-title' label="Title" variant='outlined' style={{ width: '90%' }} onChange={changeTitle} />
                  </Grid>
               :
                  <Grid>
                     <TripleRadioOptionComponent
                        getOption={getOption}
                        options={historyRadioOptions}
                     />
                     { entryType === 'photo' && showPhotoSearchComponent
                        ?
                           <Grid>
                              <TextField data-testid="history-create-photo-width" name='history-create-photo-width' label="Photo Width %" variant='outlined' style={{ width: '40%' }} onChange={changeWidth} />
                           </Grid>
                        :
                           null
                     }
                     { entryType === 'photo' && showPhotoSearchComponent ? <PhotoSearchComponent buttonLabel={'Add to History Entry'} handleAddPhoto={handleAddPhoto} /> : null }
                     <TextareaAutosize data-testid='history-text' label="Bullet / Link / Text" name="history-text" minRows={5} style={{ width: "90%", fontSize: "1rem" }} onChange={changeEntry} value={entry} />
                  </Grid>
            }

            {title.length > 0
               ?
               <Grid item style={{ marginTop: '1rem' }}>
                  <Button data-testid='history-create-submit' variant='contained' color='primary' onClick={handleSubmitTitle}>Submit</Button>
               </Grid>
               :
               <Grid item style={{ marginTop: '1rem' }}>
                  <Button variant='contained' color='primary' disabled>Submit</Button>
               </Grid>
            }
         </Grid>

      </Box>
   )
}

export default HistoryCreateComponent
